export default __webpack_public_path__ + "static/Hospitality-Photo1-fe70a75774be325faa78d214b4580d26.png";